module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_aqua_wayo-752c61edb6644c516d3316cbd447a4d3.jpg";